import { EventEmitter } from 'events';

class Events extends EventEmitter {}

export default new Events();
